// API client \u2014 mirrors the existing BibleVoice backend contract exactly,
// so this frontend is plug-and-play with the production backend.
import { mockCanon, mockVerse, mockChapter, mockChatReply } from "../mock/data";

const BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

async function request(path, opts = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { "Content-Type": "application/json" },
    ...opts,
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function recordVisit(deviceId) {
  try {
    return await request("/visit", { method: "POST", body: JSON.stringify({ deviceId }) });
  } catch (e) {
    return { today: 0, total: 0 };
  }
}

export async function getVerseOfDay(lang = "en") {
  try {
    const data = await request(`/vod?lang=${lang}`);
    return data.verse;
  } catch (e) {
    return mockVerse;
  }
}

export async function getCanon(lang = "en") {
  try {
    return await request(`/canon?lang=${lang}`);
  } catch (e) {
    return mockCanon;
  }
}

export async function getChapter(bookId, chapter, lang = "en") {
  try {
    return await request(`/bible/${bookId}/${chapter}?lang=${lang}`);
  } catch (e) {
    return mockChapter(bookId, chapter);
  }
}

export async function sendChat(messages, deviceId, lang = "en") {
  try {
    const data = await request("/chat", {
      method: "POST",
      body: JSON.stringify({ messages, deviceId, lang }),
    });
    return data.reply;
  } catch (e) {
    return mockChatReply(messages);
  }
}
